import React from 'react'

interface EyeProps {
  size?: number
  color?: string
}

export const Eye: React.FC<EyeProps> = ({
  size = 24,
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0003 3C16.8802 3 21.018 6.17769 22.4572 10.5767C22.7593 11.5001 22.7593 12.4999 22.4572 13.4233C21.018 17.8223 16.8802 21 12.0003 21C7.12033 21 2.98259 17.8223 1.54338 13.4233C1.24128 12.4999 1.24128 11.5001 1.54337 10.5767C2.98258 6.17768 7.12033 3 12.0003 3ZM12.0003 19C15.6114 19 18.7782 16.8572 20.2021 13.7144C20.6942 12.6283 20.6942 11.3717 20.2021 10.2856C18.7782 7.14278 15.6114 5 12.0003 5C8.38915 5 5.22234 7.14275 3.79845 10.2855C3.30633 11.3717 3.30633 12.6283 3.79845 13.7145C5.22233 16.8573 8.38915 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"
        fill={color}
      />
    </svg>
  )
}
